import { useState } from "react";
import TextBundle from "aldoo-ra/CMS/text-bundle";
import Modal from "aldoo-ra/Modal";
import { deleteOrg } from "./api";

export default function DeleteOrgDialog({ org, onClose, onDeleted }) {
  const [confirm, setConfirm] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState(null);

  const texts = TextBundle({ id: "aldoo_ra_organizations" });

  const match = confirm.trim() === org.name.trim();

  async function handleDelete() {
    if (!match) return;
    setDeleting(true);
    setError(null);
    try {
      const res = await deleteOrg(org._id);
      if (res.error) {
        setError(res.error);
        return;
      }
      onDeleted?.();
      onClose();
    } catch {
      setError(texts?.delete_failed);
    } finally {
      setDeleting(false);
    }
  }

  if (!texts) return null;

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      variant="centered"
      className="max-w-md"
      title={texts?.delete_org_title}
    >
      <div className="space-y-5">
        <div className="p-3 rounded-xl bg-error/10 border border-error/20 text-sm text-error">
          {texts?.delete_warning_prefix}{" "}
          <span className="font-semibold">{org.name}</span>
          {texts?.delete_warning_suffix}
        </div>

        <div className="space-y-1.5">
          <label className="text-sm font-medium text-text_secondary">
            {texts?.type_to_confirm_prefix}{" "}
            <span className="font-semibold text-text">{org.name}</span>{" "}
            {texts?.type_to_confirm_suffix}
          </label>
          <input
            type="text"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleDelete()}
            placeholder={org.name}
            autoFocus
            className="w-full px-3 py-2.5 rounded-xl border border-bordered bg-canvas text-text text-sm focus:outline-none focus:ring-2 focus:ring-error focus:border-error"
          />
        </div>

        {error && <p className="text-sm text-error">{error}</p>}

        <div className="flex gap-3 pt-1">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl border border-bordered text-sm font-medium text-text hover:bg-black/5 transition-colors"
          >
            {texts?.cancel}
          </button>
          <button
            onClick={handleDelete}
            disabled={!match || deleting}
            className="flex-1 py-2.5 rounded-xl bg-error hover:bg-error/80 disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm font-medium transition-colors"
          >
            {deleting ? texts?.deleting_btn : texts?.delete_org_btn}
          </button>
        </div>
      </div>
    </Modal>
  );
}
